import { Box, Icon, Modal, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import React from 'react'

const EditDetailsModal = ({
  error,
  editDetails,
  talentId,
  defaultValues,
  open,
  talentDetails,
  setTalentDetails,
  handleToggle,
  removeEditName = false,
}) => {
  const { name, email, contact } = defaultValues

  const nameError =
    Array.isArray(error?.data?.errors?.name) &&
    error?.data?.errors?.name &&
    error?.data?.errors?.name[0]
  const emailError =
    Array.isArray(error?.data?.errors?.email) &&
    error?.data?.errors?.email &&
    error?.data?.errors?.email[0]
  const phoneError =
    Array.isArray(error?.data?.errors?.phone) &&
    error?.data?.errors?.phone &&
    error?.data?.errors?.phone[0]

  const isDirty =
    talentDetails.name !== name || talentDetails.email !== email || talentDetails.phone !== contact

  const handleSave = () => {
    const updatedData = {
      ...(talentDetails.name !== name ? { name: talentDetails.name } : {}),
      ...(talentDetails.email !== email ? { email: talentDetails.email } : {}),
      ...(talentDetails.phone !== contact ? { phone: talentDetails.phone } : {}),
    }
    editDetails(updatedData)
  }

  return (
    <Modal
      open={open}
      onClose={handleToggle}
      sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box
        sx={{
          backgroundColor: 'white.main',
          maxWidth: '600px',
          width: '100%',
          borderRadius: '6.5px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px 24px',
            borderBottom: '1px solid #E5E5E5',
          }}
        >
          <Typography>Edit talent details</Typography>
          <Icon onClick={handleToggle} sx={{ fontSize: '20px', cursor: 'pointer' }}>
            close
          </Icon>
        </Box>
        <Box sx={{ padding: '24px 24px 0 24px', borderBottom: '1px solid #E5E5E5' }}>
          {!removeEditName && (
            <AdxInput
              label="Name"
              type="text"
              sx={{ marginBottom: '24px' }}
              value={talentDetails.name}
              onChange={(e) =>
                setTalentDetails((prev) => ({
                  name: e.target.value,
                  email: prev.email,
                  phone: prev.phone,
                }))
              }
              isErrorShown={error?.data?.errors?.name}
              errorMessage={<AdxErrorMessage>{nameError}</AdxErrorMessage>}
            />
          )}
          <AdxInput
            label="Email"
            type="email"
            sx={{ marginBottom: '24px' }}
            value={talentDetails.email}
            onChange={(e) =>
              setTalentDetails((prev) => ({
                name: prev.name,
                email: e.target.value,
                phone: prev.phone,
              }))
            }
            isErrorShown={error?.data?.errors?.email}
            errorMessage={<AdxErrorMessage>{emailError}</AdxErrorMessage>}
          />
          <AdxInput
            label="Contact number"
            type="text"
            sx={{ marginBottom: '24px' }}
            value={talentDetails.phone}
            onChange={(e) =>
              setTalentDetails((prev) => ({
                name: prev.name,
                email: prev.email,
                phone: e.target.value,
              }))
            }
            isErrorShown={error?.data?.errors?.phone}
            errorMessage={<AdxErrorMessage>{phoneError}</AdxErrorMessage>}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '10px',
            padding: '20px 24px 30px 24px',
          }}
        >
          <AdxButton variant={'ghost'} onClick={handleToggle} sx={{ width: '100px' }}>
            Cancel
          </AdxButton>
          <AdxButton
            variant={'contained'}
            disabled={!isDirty}
            type="submit"
            onClick={handleSave}
            sx={{ width: '200px' }}
          >
            Save
          </AdxButton>
        </Box>
      </Box>
    </Modal>
  )
}

export default EditDetailsModal
